import { api, responseErrorCheckSilent } from './api'

export type CurrentAlertType = 'ERROR' | 'WARN' | 'INFO' | 'OK'

export interface CurrentAlertTranslation {
  title?: string
  body?: string | null
}

export interface CurrentAlert {
  id: string
  lastModifyDate: string
  type: CurrentAlertType
  title: string
  body?: string | null
  translations?: Record<string, CurrentAlertTranslation>
}

export class Alerts {
  static endpoint = '/api/v1/alerts'

  static current(client: string): Promise<CurrentAlert[]> {
    return api.get<CurrentAlert[]>(`${this.endpoint}/current`, { client }).then(responseErrorCheckSilent)
  }
}
